import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router';

import type { IncidentPsap, Position } from '@/signalr';
import { incidentListRoute } from '@/features/shared/routes';
import {
  closeIncident as closeIncidentCommand,
  openAddPsapToIncidentDialog,
  openShareByLinkDialog as openShareByLinkDialogAction,
} from './actions';
import { useActionsMobileMenuContainer } from './layout/actionsMobileMenu';
import { IncidentDetailActionBarItems } from './IncidentDetailActionBarItems';

export type IncidentDetailActionBarProps = {
  incidentIsReadOnly: boolean;
  incidentId: string;
  lastCallerPosition: Position | null;
  involvedPsaps?: readonly IncidentPsap[];
};

export function IncidentDetailActionBar({ incidentIsReadOnly, incidentId }: IncidentDetailActionBarProps) {
  const actionsMobileMenuContainer = useActionsMobileMenuContainer();
  const navigate = useNavigate();

  const openShareByLinkDialog = () => {
    openShareByLinkDialogAction(incidentId);
  };

  const closeIncident = async () => {
    await closeIncidentCommand(incidentId);
    void navigate(incidentListRoute());
  };

  const addPsapToIncident = () => {
    openAddPsapToIncidentDialog(incidentId);
  };

  return (
    <>
      <div className="d-none d-tablet-flex flex-wrap justify-content-end gap-1 align-items-center mb-2">
        <IncidentDetailActionBarItems
          incidentId={incidentId}
          incidentIsReadOnly={incidentIsReadOnly}
          onAddPsapToIncident={addPsapToIncident}
          onCloseIncident={closeIncident}
          onOpenShareByLinkDialog={openShareByLinkDialog}
        />
      </div>

      {actionsMobileMenuContainer !== null &&
        createPortal(
          <div className="d-flex flex-column p-2 gap-2">
            <IncidentDetailActionBarItems
              incidentId={incidentId}
              incidentIsReadOnly={incidentIsReadOnly}
              onAddPsapToIncident={addPsapToIncident}
              onCloseIncident={closeIncident}
              onOpenShareByLinkDialog={openShareByLinkDialog}
            />
          </div>,
          actionsMobileMenuContainer,
        )}
    </>
  );
}
